import React from 'react';
import cx from 'classnames';

import s from './VideoPlayer.module.scss';

export interface IVideoPlayer {
  src: string;
  poster?: string;
}

const VideoPlayer = ({ poster, src }: IVideoPlayer) => (
  <div className={cx(s.VideoPlayer)}>
    <video
      autoPlay
      className={s.VideoPlayerTag}
      controls
      poster={poster}
      src={src}
    >
      <track
        kind="captions"
      />
    </video>
  </div>
);

export default VideoPlayer;
